// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__container___LHzOD {
  background: white;
  padding: 20px 40px 44px !important;
}
.styles__supplier___tLL4r {
  background: transparent;
  color: #0988cd;
}
.styles__sections___htzCP {
  display: flex;
  justify-content: space-between;
}
@media (max-width: 767px) {
  .styles__sections___htzCP {
    flex-direction: column;
  }
}
.styles__list___PaYni {
  list-style: none;
  padding-left: 0;
}
.styles__icon___P3H9L {
  color: #1ec188;
  margin-right: 8px;
}
.styles__suppliersList___p4Q4O {
  display: flex;
  flex-direction: column;
  width: 50%;
}
@media (max-width: 767px) {
  .styles__suppliersList___p4Q4O {
    width: 100%;
  }
}
.styles__supplierButton___e6wky {
  text-align: left;
  font-weight: bold;
  color: #0988cd;
  cursor: pointer;
  padding-bottom: 10px;
}
.styles__supplierName___tfkzN {
  color: #0988cd;
  font-size: 14px;
  font-weight: bold;
  margin-top: 8px;
  margin-bottom: 8px;
}
.styles__preorderActive___eJHPi {
  color: #8dd7cf;
  font-size: 14px;
  font-weight: bold;
}
.styles__chooseTarget___UTSIK {
  width: 50%;
}
@media (max-width: 767px) {
  .styles__chooseTarget___UTSIK {
    width: 100%;
  }
}
.styles__target___RHdUm {
  display: flex;
  flex-direction: column;
  border: 1px solid black;
  padding: 10px;
  width: 320px;
}
@media (max-width: 767px) {
  .styles__target___RHdUm {
    width: 100%;
  }
}
.styles__targetTitle___EsdgS {
  font-weight: bold;
}
.styles__actions___Ye0aG {
  margin-top: 20px;
  margin-bottom: 20px;
  width: 320px;
  display: flex;
  justify-content: space-between;
}
@media (max-width: 767px) {
  .styles__actions___Ye0aG {
    width: 100%;
  }
}
.styles__cancelButton___V7L0S {
  color: red !important;
  padding: 0 !important;
  background-color: transparent !important;
  border: transparent !important;
}
.styles__cancelButton___V7L0S:active,
.styles__cancelButton___V7L0S:focus {
  border: transparent !important;
  outline: none !important;
  box-shadow: unset !important;
}
.styles__changeTargetButton___RUHMO {
  color: blue !important;
  background-color: transparent !important;
  border: transparent !important;
  padding: 0 !important;
}
.styles__changeTargetButton___RUHMO:active,
.styles__changeTargetButton___RUHMO:focus {
  border: transparent !important;
  outline: none !important;
  box-shadow: unset !important;
}
.styles__changeTargetButton___RUHMO:disabled {
  color: #7F7F7F !important;
}
.styles__selectedTarget___uoLQM {
  background-color: #fbe192;
}
.styles__unselectedTarget___V22uR {
}
@media (max-width: 767px) {
  .styles__unselectedTarget___V22uR {
    width: calc(100% - 30px);
  }
}
.styles__targetReached___WXNzH {
  background-color: #8dd7cf;
}
.styles__targetWrapper___vnbtL {
  margin-top: 20px;
  display: flex;
  align-items: center;
}
.styles__selectedTargetIcon___Q7aVy {
  font-size: 20px;
  color: #1ec188;
  margin-left: 10px;
}
.styles__preorderStepsTitle___MJofl {
  margin-top: 24px;
  font-size: 20px;
}
.styles__listItem___hmAl4 {
  margin-bottom: 8px;
  font-size: 15px;
}
.styles__targetDescription___xtD8s {
  line-height: 2;
}
.styles__startButton___ilRph {
  background-color: #0988cd !important;
}
.styles__fullWidthButton___X9iuW {
  margin-bottom: 20px !important;
  width: 320px;
}
@media (max-width: 767px) {
  .styles__fullWidthButton___X9iuW {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/components/PreOrder/styles.less"],"names":[],"mappings":"AAEA;EACE,iBAAA;EACA,kCAAA;AADF;AAIA;EACE,uBAAA;EACA,cAAA;AAFF;AAKA;EACE,aAAA;EACA,8BAAA;AAHF;AAIE;EAAA;IACE,sBAAA;EADF;AACF;AAIA;EACE,gBAAA;EACA,eAAA;AAFF;AAKA;EACE,cAAA;EACA,iBAAA;AAHF;AAMA;EACE,aAAA;EACA,sBAAA;EACA,UAAA;AAJF;AAKE;EAAA;IACE,WAAA;EAFF;AACF;AAKA;EACE,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,oBAAA;AAHF;AAMA;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;AAJF;AAQA;EACE,cAAA;EACA,eAAA;EACA,iBAAA;AANF;AASA;EACE,UAAA;AAPF;AAQE;EAAA;IACE,WAAA;EALF;AACF;AAQA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,aAAA;EACA,YAAA;AANF;AAOE;EAAA;IACE,WAAA;EAJF;AACF;AAOA;EACE,iBAAA;AALF;AAQA;EACE,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;AANF;AAOE;EAAA;IACE,WAAA;EAJF;AACF;AAOA;EACE,qBAAA;EACA,qBAAA;EACA,wCAAA;EACA,8BAAA;AALF;AAME;;EACE,8BAAA;EACA,wBAAA;EACA,4BAAA;AAHJ;AAOA;EACE,sBAAA;EACA,wCAAA;EACA,8BAAA;EACA,qBAAA;AALF;AAME;;EACE,8BAAA;EACA,wBAAA;EACA,4BAAA;AAHJ;AAKE;EACE,yBAAA;AAHJ;AAOA;EAEE,yBAAA;AALF;AAQA;AALA;AAOE;EAAA;IACE,wBAAA;EAJF;AACF;AAMA;EAEE,yBAAA;AAJF;AAOA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;AALF;AAQA;EACE,eAAA;EACA,cAAA;EACA,iBAAA;AANF;AASA;EACE,gBAAA;EACA,eAAA;AAPF;AAUA;EACE,kBAAA;EACA,eAAA;AARF;AAWA;EACE,cAAA;AATF;AAYA;EACE,oCAAA;AAVF;AAaA;EACE,8BAAA;EACA,YAAA;AAXF;AAYE;EAAA;IACE,WAAA;EATF;AACF","sourcesContent":[" @import '../../../shared/variables.less';\n\n.container {\n  background: white;\n  padding: 20px 40px 44px !important;\n}\n\n.supplier {\n  background: transparent;\n  color: @eon-link-color;\n}\n\n.sections {\n  display: flex;\n  justify-content: space-between;\n  @media (max-width: @screen-xs-max) {\n    flex-direction: column;\n  }\n}\n\n.list {\n  list-style: none;\n  padding-left: 0;\n}\n\n.icon {\n  color: @success;\n  margin-right: 8px;\n}\n\n.suppliersList {\n  display: flex;\n  flex-direction: column;\n  width: 50%;\n  @media(max-width: @screen-xs-max) {\n    width: 100%;\n  }\n}\n\n.supplierButton {\n  text-align: left;\n  font-weight: bold;\n  color: @eon-link-color;\n  cursor: pointer;\n  padding-bottom: 10px;\n}\n\n.supplierName {\n  color: @eon-link-color;\n  font-size: 14px;\n  font-weight: bold;\n  margin-top: 8px;\n  margin-bottom: 8px;\n}\n\n\n.preorderActive {\n  color: #8dd7cf;\n  font-size: 14px;\n  font-weight: bold;\n}\n\n.chooseTarget {\n  width: 50%;\n  @media(max-width: @screen-xs-max) {\n    width: 100%;\n  }\n}\n\n.target {\n  display: flex;\n  flex-direction: column;\n  border: 1px solid black;\n  padding: 10px;\n  width: 320px;\n  @media(max-width: @screen-xs-max) {\n    width: 100%;\n  }\n}\n\n.targetTitle {\n  font-weight: bold;\n}\n\n.actions {\n  margin-top: 20px;\n  margin-bottom: 20px;\n  width: 320px;\n  display: flex;\n  justify-content: space-between;\n  @media(max-width: @screen-xs-max) {\n    width: 100%;\n  }\n}\n\n.cancelButton {\n  color: red !important;\n  padding: 0 !important;\n  background-color: transparent !important;\n  border: transparent !important;\n  &:active, &:focus {\n    border: transparent !important;\n    outline: none !important;\n    box-shadow: unset !important;\n  }\n}\n\n.changeTargetButton {\n  color: blue !important;\n  background-color: transparent !important;\n  border: transparent !important;\n  padding: 0 !important;\n  &:active, &:focus {\n    border: transparent !important;\n    outline: none !important;\n    box-shadow: unset !important;\n  }\n  &:disabled {\n    color: @eon-text-color-muted !important;\n  }\n}\n\n.selectedTarget {\n  composes: target;\n  background-color: #fbe192;\n}\n\n.unselectedTarget {\n  composes: target;\n  @media(max-width: @screen-xs-max) {\n    width: calc(100% - 30px);\n  }\n}\n.targetReached {\n  composes: target;\n  background-color: #8dd7cf;\n}\n\n.targetWrapper {\n  margin-top: 20px;\n  display: flex;\n  align-items: center;\n}\n\n.selectedTargetIcon {\n  font-size: 20px;\n  color: @success;\n  margin-left: 10px;\n}\n\n.preorderStepsTitle {\n  margin-top: 24px;\n  font-size: 20px;\n}\n\n.listItem {\n  margin-bottom: 8px;\n  font-size: 15px;\n}\n\n.targetDescription {\n  line-height: 2;  \n}\n\n.startButton {\n  background-color: @eon-link-color !important;\n}\n\n.fullWidthButton {\n  margin-bottom: 20px !important;\n  width: 320px;\n  @media(max-width: @screen-xs-max) {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles__container___LHzOD`,
	"supplier": `styles__supplier___tLL4r`,
	"sections": `styles__sections___htzCP`,
	"list": `styles__list___PaYni`,
	"icon": `styles__icon___P3H9L`,
	"suppliersList": `styles__suppliersList___p4Q4O`,
	"supplierButton": `styles__supplierButton___e6wky`,
	"supplierName": `styles__supplierName___tfkzN`,
	"preorderActive": `styles__preorderActive___eJHPi`,
	"chooseTarget": `styles__chooseTarget___UTSIK`,
	"target": `styles__target___RHdUm`,
	"targetTitle": `styles__targetTitle___EsdgS`,
	"actions": `styles__actions___Ye0aG`,
	"cancelButton": `styles__cancelButton___V7L0S`,
	"changeTargetButton": `styles__changeTargetButton___RUHMO`,
	"selectedTarget": `styles__selectedTarget___uoLQM styles__target___RHdUm`,
	"unselectedTarget": `styles__unselectedTarget___V22uR styles__target___RHdUm`,
	"targetReached": `styles__targetReached___WXNzH styles__target___RHdUm`,
	"targetWrapper": `styles__targetWrapper___vnbtL`,
	"selectedTargetIcon": `styles__selectedTargetIcon___Q7aVy`,
	"preorderStepsTitle": `styles__preorderStepsTitle___MJofl`,
	"listItem": `styles__listItem___hmAl4`,
	"targetDescription": `styles__targetDescription___xtD8s`,
	"startButton": `styles__startButton___ilRph`,
	"fullWidthButton": `styles__fullWidthButton___X9iuW`
};
export default ___CSS_LOADER_EXPORT___;
